import { NEWBUILDING_TRUST_AND_SAFETY, NEWBUILDING_RENT_TRAP } from 'shared/selectors/abExperiments';

export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';
export const AUD_AUTH_TRAP = 'aud_web_adsc_99_auth_traps';

export const EXPERIMENTS: string[] = [
  NEWBUILDING_TRUST_AND_SAFETY,
  AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT,
  NEWBUILDING_RENT_TRAP,
  AUD_AUTH_TRAP,
];
